<app-common-datagrid
	#dataTable
	[id]="tableId"
	[columns]="columns"
	[rows]="rows"
	[selectedRows]="selectedRows"
	[selectionType]="'multi'"
	(select)="tableInfo.onSelect($event)"
></app-common-datagrid>
<ng-template #geomErrorColumnTempl let-row="row" let-column="column" let-value="value">
	<div [ngClass]="{'geom-qc-cell': true}">
		<i  *ngIf="row[geomColName_manual]" class="glyphicons glyphicons-globe"></i>
	</div>
</ng-template>
<button (click)="setRows()">SetRows</button>